/** Common passport / visa background color presets — no API calls */

export const VISA_COLOR_PRESETS = [
  { name: 'White', color: '#FFFFFF', desc: 'US, India, UK' },
  { name: 'Light Blue', color: '#0052B4', desc: 'EU Schengen' },
  { name: 'Off White', color: '#F5F5F5', desc: 'Studio neutral' },
  { name: 'Light Gray', color: '#E8E8E8', desc: 'ID photos' },
];
